import colors from "../../styles/variables.scss";

export default colors;
